import * as React from 'react';
import { Image } from 'react-native';

export function Logo(props) {
  return(
    <Image style={props.size}  source={require('../assets/images/logo.png')} />
  )
}